/**
 * 주문현황 URL
 */
export const OM_URL = "/repair-shop/order-mgmt";
